// Generated from the English keys in lib/i18n.ts (same {slot} placeholders); reviewed 2026-09-11.
export const TR: Record<string, string> = {
  "Guess the Goal": "Guess the Goal",
  "Name the iconic goal — real rewards, server-scored": "İkonik golü tahmin et — gerçek ödüller, sunucu skorlu",
  "Solved {n}/{total}": "Çözüldü {n}/{total}",
  "+{points} points": "+{points} puan",
  "Move {n}/{total}": "İlerle {n}/{total}",
  "Which goal is this?": "Bu gol hangisi?",
  "Bonus question": "Bonus soru",
  "Next goal": "Sonraki gol",
  "Guess the Goal is warming up — check back soon": "Guess the Goal hazırlanıyor — yakında tekrar kontrol et",
  "A legendary goal replays on the coaching board. The earlier you name it, the more you earn — first solve of each goal pays coins and XP.": "Efsanevi bir gol antrenman tahtasında tekrar oynuyor. Ne kadar erken tahmin edersen o kadar çok kazanırsın — her golün ilk çözümü jeton ve XP kazandırır.",
  "(daily cap)": "(günlük limit)",
  "Name the legendary goal from the coaching board": "Taktik tahtasındaki efsane golü bil",
  "A legendary goal replays on the coaching board. Watch the moves and name the goal. Sign in to earn coins and XP.": "Efsane bir gol taktik tahtasında yeniden oynanıyor. Hamleleri izle ve golü bil. Coin ve XP kazanmak için giriş yap.",
  "Sign in to earn coins and XP for every goal you solve": "Bildiğin her golden coin ve XP kazanmak için giriş yap",
  "Already solved before — no repeat rewards": "Daha önce çözüldü — tekrar ödül yok",
  "Something went wrong — try again": "Bir şeyler ters gitti — tekrar dene",
  "Watch the real goal": "Gerçek golü izle",
  "Back to the board": "Tahtaya geri dön",
  "Board": "Tahta",
  "Video": "Video",
  "Replay board": "Tahtayı tekrar oyna",
  "Couldn't load your game": "Oyunun yüklenemedi",
  "Prototype — virtual points only, no real money or rewards": "Prototip — sadece sanal puanlar, gerçek para veya ödül yok",
  "Points": "Puanlar",
  "Play again": "Tekrar oyna",
  "Try again": "Tekrar dene",
  "Next": "Sonraki",
  "Back": "Geri",
  "Opponent": "Rakip",
  "Accumulator": "Kombine",
  "Five legs. One stake. All must land.": "Beş ayak. Bir bahis. Hepsi tutmalı.",
  "Pick 5 legs · {n}/5": "5 ayak seç · {n}/5",
  "Continue · {odds}x": "Devam et · {odds}x",
  "Potential return": "Potansiyel kazanç",
  "Your stake": "Bahsin",
  "Place bet · {stake}": "Bahis yap · {stake}",
  "Back to legs": "Ayaklara dön",
  "Return so far": "Şu ana kadarki kazanç",
  "4 of 5 landed!": "5'te 4 tuttu!",
  "Take the money or go for it?": "Parayı al ya da devam et?",
  "One leg left. Cash out now, or risk it for the full {amount}.": "Son ayak kaldı. Şimdi bozdur, yoksa tam {amount} için riske gir.",
  "Cash out": "Parayı bozdur",
  "Final leg": "Son ayak",
  "Bet won!": "Bahis kazandı!",
  "Busted on leg {n}": "{n}. turda battın",
  "Lost your {stake} stake — one leg let it down.": "{stake} jetonluk bahsin kaybetti — bir tur seni yarı yolda bıraktı.",
  "New accumulator": "Yeni kombine",
  "if it lands:": "Eğer gelirse:",
  "{leg}/{total} legs": "{leg}/{total} tur",
  "Leg {n}": "{n}. tur",
  "Answer right to boost your odds": "Oranlarını yükseltmek için doğru cevap ver",
  "Bet Slip · Treble": "Bahis Kuponu · Üçlü",
  "3 selections": "3 seçim",
  "boosted": "artırıldı",
  "Total odds": "Toplam oran",
  "Boost leg {n} · {club}": "{n}. turu · {club} artır",
  "Boosted {a} → {b}": "Artırıldı {a} → {b}",
  "Stake {stake} · potential return": "{stake} jeton · potansiyel kazanç",
  "Slip landed!": "Kupon geldi!",
  "Not this time": "Bu sefer değil",
  "The boosted {odds}x didn't come in.": "Artırılmış {odds}x oran gelmedi.",
  "New slip": "Yeni kupon",
  "Bank it or climb — one wrong answer wipes it all": "Kaydet ya da devam et — tek yanlış cevap hepsini siler",
  "Stake": "Jeton",
  "Wiped": "Kaybettin",
  "Banked": "Aldın",
  "Pot at risk": "Riskteki pot",
  "{mult}x on {stake}": "{mult}x üzerine {stake}",
  "Stake {stake} & climb": "{stake} jeton koy ve tırman",
  "Bank {pot} now, or risk it for {next}?": "Şimdi {pot} al, yoksa {next} için riske mi at?",
  "Bank {pot}": "{pot} al",
  "Climb to {mult}x": "{mult}x'e tırman",
  "Wiped!": "Kaybettin!",
  "Wrong answer at {mult}x — the whole pot is gone.": "Yanlış cevap {mult}x'te — tüm pot gitti.",
  "Banked {amount}": "{amount} alındı",
  "😱 It would have hit 32x!": "😱 32x olacaktı!",
  "Smart! You'd have busted at {mult}x.": "Akıllıca! {mult}x'te batacaktın.",
  "It would've climbed to {a}x then busted at {b}x.": "{a}x'e tırmanıp sonra {b}x'te batacaktı.",
  "Go again": "Tekrar oyna",
  "One hard question. Winner takes the pot.": "Bir zor soru. Kazanan potu alır.",
  "Today's pot": "Bugünkü pot",
  "climbing with every miss…": "her yanlış cevapta artıyor…",
  "failed today": "bugün başaramadın",
  "next question": "sonraki soru",
  "Hard · one attempt": "Zor · tek deneme",
  "Rolled over": "Devretti",
  "Not this time — your entry fed the pot. It now sits at {pot}. Come back for the next question in {time}.": "Bu sefer değil — girişin kasaya gitti. Kasa şimdi {pot}. Bir sonraki soru için {time} sonra geri gel.",
  "Replay": "Tekrar Oyna",
  "Jackpot won!": "Jackpot kazandı!",
  "The pot resets for tomorrow's question.": "Kasa yarınki soru için sıfırlanıyor.",
  "Live": "Canlı",
  "Half-Time Quiz": "Devre Arası Quiz",
  "Question {n} / {total}": "Soru {n} / {total}",
  "Get {n}+ for a free bet · {c} right": "{n}+ doğru bilerek bedava bahis kazan · {c} doğru",
  "Free bet won!": "Bedava bahis kazandı!",
  "{c}/{total} — so close": "{c}/{total} — çok yaklaştın",
  "You earned a virtual second-half free bet (demo — no real rewards).": "Sanal ikinci yarı bedava bahsi kazandın (demo — gerçek ödül yok).",
  "Get {n}+ right before kickoff to earn a free bet.": "Maç öncesi {n}+ doğru bilerek bedava bahis kazan.",
  "Markets": "Piyasalar",
  "Odds are illustrative · prototype": "Oranlar temsili · prototip",
  "Prototype — virtual only": "Prototip — sadece sanal",
  "Odds Board": "Oran Tablosu",
  "Every answer is a market — back your call": "Her cevap bir piyasa — bahsini yap",
  "Market {n}": "Pazar {n}",
  "{pct}% implied": "%{pct} ima edilen",
  "returns": "getiriler",
  "Pick an answer to back": "Desteklemek için bir cevap seç",
  "Place {stake} on {answer}": "{answer} üzerine {stake} yatır",
  "Won {amount}!": "{amount} Kazandın!",
  "Lost {amount}": "{amount} Kaybettin",
  "Big-odds call!": "Yüksek oranlı tahmin!",
  "Right answer:": "Doğru cevap:",
  "Next market": "Sonraki pazar",
  "Pass Chain": "Pass Chain",
  "Link the two players through shared clubs": "İki oyuncuyu ortak kulüpler aracılığıyla bağla",
  "Fewer links score higher": "Daha az bağlantı daha yüksek puan alır",
  "Par —": "Par —",
  "Par {par} links": "Par {par} bağlantı",
  "Who links to {name}?": "{name} ile kimler bağlantılı?",
  "Add": "Ekle",
  "Already in the chain": "Zincirde zaten var",
  "Unknown player — try another": "Bilinmeyen oyuncu — başkasını dene",
  "{a} never played with {b}": "{a} ile {b} hiç oynamadı",
  "Reset": "Sıfırla",
  "Linked!": "Bağlandı!",
  "{n} links": "{n} bağlantı",
  "Par — perfect!": "Par — mükemmel!",
  "par {n}": "par {n}",
  "Next chain": "Sonraki zincir",
  "START": "BAŞLA",
  "TARGET": "HEDEF",
  "Penalty Shootout": "Penaltı Atışları",
  "Round {n} / {total}": "Tur {n} / {total}",
  "You · AI": "Sen · Yapay Zeka",
  "Answer to earn your shot": "Şutunu kazanmak için cevapla",
  "Opponent is stepping up…": "Rakip geliyor…",
  "AI is on target — get ready to dive!": "Yapay Zeka hedefte — dalmaya hazır ol!",
  "AI answering…": "Yapay Zeka cevaplıyor…",
  "Pick your corner — beat the keeper": "Köşeni seç — kaleciyi geç",
  "You're in goal — pick your dive!": "Kalecisin — dalışını seç!",
  "GOAL!": "GOL!",
  "MISSED": "KAÇTI",
  "AI SCORES": "YAPAY ZEKA SKOR YAPTI",
  "SAVED!": "KURTARIŞ!",
  "Opponent's turn": "Rakibin sırası",
  "See result": "Sonucu gör",
  "Next round": "Sonraki tur",
  "You win!": "Kazandın!",
  "Draw": "Beraberlik",
  "You lose": "Kaybettin",
  "Free Kicks": "Free Kicks",
  "Know football. Read the goal. Take the shot.": "Futbolu bil. Golü oku. Vuruşu yap.",
  "Balance": "Bakiye",
  "Pot": "Pot",
  "Your pot": "Senin potun",
  "Stake {n} & attack": "{n} jeton koy & saldır",
  "Min {n}": "Min {n}",
  "Top up (demo)": "Doldur (demo)",
  "Answer to scout the keeper": "Kaleciyi gözlemlemek için cevap ver",
  "{n}s": "{n} saniye",
  "Time's up — blind shot": "Süre doldu — kör atış",
  "Wrong — the correct answer stays. Blind shot.": "Yanlış — doğru cevap kalır. Kör atış.",
  "Answer to scout the keeper — knowledge sharpens the shot, the risk stays.": "Kaleciyi gözlemlemek için cevap ver — bilgi vuruşu keskinleştirir, risk devam eder.",
  "Attack {n}": "Saldır {n}",
  "SCOUT REPORT ✓ — one save zone revealed": "GÖZLEM RAPORU ✓ — bir kurtarış bölgesi açıldı",
  "No scout — blind shot pays more": "Gözlem yok — kör atış daha çok kazandırır",
  "Pick your shot zone": "Atış bölgesini seç",
  "4 GOAL · 2 SAVE": "4 GOL · 2 KURTARIŞ",
  "4 GOAL · 1 SAVE": "4 GOL · 1 KURTARIŞ",
  "TAKE {amount}": "AL {amount}",
  "NEXT ATTACK": "SONRAKİ SALDIRI",
  "Next attack risks the whole pot — the keeper resets.": "Sonraki saldırı tüm potu riske atar — kaleci sıfırlanır.",
  "The keeper read it — pot lost.": "Kaleci okudu — pot kaybedildi.",
  "Cashed out {amount}!": "{amount} bozduruldu!",
  "Loading…": "Yükleniyor…",
  "Could not load balance — tap to retry": "Bakiye yüklenemedi — tekrar denemek için dokun",
  "New round": "Yeni tur",
  "Live wins": "Canlı galibiyetler",
  "Longest runs today": "Bugünün en uzun serileri",
  "{n} playing now": "{n} şu anda oynuyor",
  "{pct}% answered correctly": "%{pct} doğru cevaplandı",
  "{pct}% scored": "%{pct} gol attı",
  "{pct}% cashed out": "%{pct} bozdurdu",
  "{n} going NEXT ATTACK": "SON ATAKTA {n} KİŞİ",
  "You": "Sen",
  "just now": "az önce",
  "{n}m ago": "{n} dk önce",
  "Squad Collection": "Kadroyu Topla",
  "Answer to pull cards. Build your XI.": "Kart çekmek için cevapla. Kendi XI'ini kur.",
  "Squad": "Kadron",
  "Answer to earn a pack": "Paket kazanmak için cevapla",
  "Tap to open": "Açmak için dokun",
  "Add to squad": "Kadroyu ekle",
  "Squad complete!": "Kadron tamamlandı!",
  "Reward: +2,000 🪙": "Ödül: +2.000 🪙",
  "Start a new squad": "Yeni bir kadro başlat",
  "Bronze": "Bronz",
  "Silver": "Gümüş",
  "Gold": "Altın",
  "Special": "Özel",
  "Easy": "Kolay",
  "Hard": "Zor",
  "Expert": "Uzman",
  "Name a player who fits every reel": "Her yuvaya uyan bir oyuncu söyle",
  "{n} reels": "{n} yuva",
  "Spin": "Çevir",
  "Spinning…": "Çevriliyor…",
  "Name a player…": "Bir oyuncu söyle…",
  "Go": "Git",
  "Hold a reel, respin the rest": "Bir yuvayı tut, diğerlerini tekrar çevir",
  "Respin −{n}": "Tekrar çevir −{n}",
  "Last 3 spins": "Son 3 çevirme",
  "Missed": "Kaçırdın",
  "Correct!": "Doğru!",
  "Only {pct}% named this": "Sadece %{pct} bunu söyledi",
  "rarity": "nadirlik",
  "Time's up": "Süre doldu",
  "You could've said:": "Şunu söyleyebilirdin:",
  "No valid player for that combo!": "Bu kombinasyon için geçerli oyuncu yok!",
  "Spin again": "Tekrar çevir",
  "Hold reel": "Yuvayı tut",
  "Release reel": "Yuvayı bırak",
  "Club": "Kulüp",
  "Position": "Pozisyon",
  "Nation": "Millet",
  "Era": "Dönem",
  "Trophy": "Kupa",
  "easy": "kolay",
  "medium": "orta",
  "hard": "zor",
  "Answer to earn spins — the wheel pays out": "Dönüş kazanmak için cevapla — çark ödeme yapar",
  "Coins": "Jeton",
  "Question {n}": "Soru {n}",
  "+1 spin earned": "+1 dönüş kazandın",
  "No spin — try the next one": "Dönüş yok — bir sonrakini dene",
  "{n} spins available": "{n} dönüş mevcut",
  "JACKPOT!": "BÜYÜK İKRAMİYE!",
  "Spin the wheel": "Çarkı döndür",
  "Answer to earn a spin": "Dönüş kazanmak için cevapla",
  "Full Time Result": "Maç Sonucu",
  "Next Goal": "Sıradaki Gol",
  "Total Goals Over/Under 3.5": "Toplam Gol 3.5 Üst/Alt",
  "Both Teams to Score — 2nd Half": "İki Takım da Gol Atar — 2. Yarı",
  "No more goals": "Daha fazla gol yok",
  "Over 3.5": "3.5 Üstü",
  "Under 3.5": "3.5 Altı",
  "Yes": "Evet",
  "No": "Hayır",
  "Champions League · Group Stage": "Şampiyonlar Ligi · Grup Aşaması",
  "Real Madrid to win": "Real Madrid kazanır",
  "Man City to win": "Man City kazanır",
  "Bayern to win": "Bayern kazanır",
  "Goalkeeper": "Kaleci",
  "Zone": "Bölge",
  "Defender": "Defans",
  "Midfielder": "Orta Saha",
  "Forward": "Forvet",
  "World Cup": "Dünya Kupası",
  "League": "Lig",
  "Champions League": "Şampiyonlar Ligi",
  "League Title": "Lig Şampiyonluğu",
  "Football Tic Tac Toe": "Futbol Tik Tak Toe",
  "Claim cells with players — three in a row wins": "Oyuncularla kareleri kap - üçlü kazandırır",
  "You · Opponent": "Sen · Rakip",
  "Pick a cell and name a player who played for that club AND that nation. Your opponent answers back — line up three to win.": "Bir hücre seç ve o kulüpte VE o ülkede oynamış bir oyuncu söyle. Rakibin cevap verir — kazanmak için üçünü sırala.",
  "Start match": "Maçı başlat",
  "Your turn — pick a cell": "Sıra sende — bir hücre seç",
  "Not a match — turn passes": "Eşleşme yok — sıra rakipte",
  "Time's up — turn passes": "Süre doldu — sıra rakipte",
  "Pass": "Pas",
  "Opponent blanked — your turn!": "Rakip boş bıraktı — sıra sende!",
  "Opponent is thinking…": "Rakip düşünüyor…",
  "Opponent wins": "Rakip kazandı",
  "Three in a row!": "Üçlü tamamlandı!",
  "Board full — {a} cells vs {b}": "Tahta doldu — {a} hücre vs {b}",
  "New grid": "Yeni tahta",
  "{pct}%": "%{pct}",
  "Brazil": "Brezilya",
  "France": "Fransa",
  "Argentina": "Arjantin",
  "Spain": "İspanya",
  "Netherlands": "Hollanda",
  "Portugal": "Portekiz",
  "Survivor": "Hayatta Kalan",
  "One wrong answer and you are out — how long can you last?": "Bir yanlış cevap ve oyundan çıktın — ne kadar dayanabilirsin?",
  "Streak": "Seri",
  "Sudden death": "Tek golle ölüm",
  "Questions get harder as you go. {n} virtual players start with you — outlast them all.": "Sorular ilerledikçe zorlaşıyor. Seninle birlikte {n} sanal oyuncu başlıyor — hepsini geride bırak.",
  "Best streak: {n}": "En iyi seri: {n}",
  "Enter the arena": "Arenaya gir",
  "Still standing": "Hâlâ ayakta",
  "Eliminated": "Elendin",
  "Streak of {n}": "{n} serisi",
  "You outlasted {pct}% of the field — {left} were still standing.": "Oyuncuların %{pct}sini geride bıraktın — {left} kişi ayakta kaldı.",
  "New best!": "Yeni rekor!",
  "Run it back": "Tekrar dene",
  "Last one standing!": "Son ayakta kalan!",
  "You cleared every question in the bank — a perfect {n}-answer run.": "Tüm soruları doğru cevapladın — mükemmel {n} cevaplık bir seri.",
  "Hi-Lo Ride": "Yüksek-Düşük Yarışı",
  "Call the higher stat — odds priced by how many get it right": "Daha yüksek istatistiği tahmin et — oranlar kaç kişinin doğru bildiğine göre belirlenir",
  "Chain higher-or-lower calls. Every correct call multiplies your stake — hard matchups pay more. Cash out before you miss.": "Zincirleme yüksek-düşük tahminler. Her doğru tahmin bahsini katlar — zorlu eşleşmeler daha çok öder. Kaybetmeden önce paranı çek.",
  "Stake {stake} & ride": "Bahis {stake} & devam et",
  "Step {n} · odds": "{n}. Adım · oran",
  "{pct}% of players call this one right": "Oyuncuların %{pct}si bu tahmini doğru bildi",
  "Which is higher?": "Hangisi daha yüksek?",
  "Higher": "Daha yüksek",
  "Pot is {pot}. Next matchup pays {odds}x → {next}.": "Pot {pot}. Sıradaki maç {odds}x ödeme yapıyor → {next}.",
  "Cash out {pot}": "Boşalt {pot}",
  "Ride on": "Devam et",
  "Wrong call": "Yanlış tahmin",
  "The ride ends — your {stake} stake is gone.": "Yolculuk bitti — {stake} bahsin gitti.",
  "New ride": "Yeni yolculuk",
  "Cashed {amount}!": "{amount} kazandın!",
  "{n} correct calls — {mult}x your stake.": "{n} doğru tahmin — bahsinin {mult}x'i.",
  "Trivia Mines": "Trivia Mayınları",
  "Dribble past hidden defenders — scout them with your knowledge": "Gizli defans oyuncularını geç - futbol bilginle onları keşfet",
  "{d} defenders hide in {n} tiles. Every clean dribble grows the pot — hit a defender and lose it all. Answer questions to scout defenders out.": "{d} defans oyuncusu {n} kutuda gizli. Her temiz geçiş potu büyütür - bir defansa çarpıp hepsini kaybedersin. Defans oyuncularını keşfetmek için soruları yanıtla.",
  "Stake {stake} & dribble": "{stake} bahis yap ve ilerle",
  "Tackled": "Top kapıldı",
  "Now · next tile": "Şimdi · sonraki kutu",
  "Scout ({n} left)": "Keşfet ({n} kaldı)",
  "{n} safe tiles opened · {d} defenders in play": "{n} güvenli kutu açıldı · {d} defans oyuncusu oyunda",
  "Scout report — a defender is marked!": "Keşif raporu - bir defans oyuncusu işaretlendi!",
  "Scout failed — no intel": "Keşif başarısız - bilgi yok",
  "Answer to scout a defender": "Bir defans oyuncusunu keşfetmek için cevapla",
  "Tackled!": "Top kapıldı!",
  "A defender got you after {n} clean tiles — the pot is gone.": "Bir defans oyuncusu {n} temiz karodan sonra seni yakaladı — pot gitti.",
  "New run": "Yeni tur",
  "{n} clean dribbles at {mult}x.": "{n} temiz top sürme {mult}x oranla.",
  "Quiz Board": "Quiz Tahtası",
  "Pick tiles, bank the value — steal when the AI slips": "Karoları seç, değeri kasaya ekle — yapay zeka hata yaparsa çal",
  "Nine tiles, three value tiers. Answer to bank the tile and keep control — miss and the AI can steal. Highest bank wins.": "Dokuz karo, üç değer kademesi. Kasaya eklemek ve kontrolü elinde tutmak için cevapla — kaçırırsan yapay zeka çalabilir. En yüksek kasa kazanır.",
  "Start game": "Oyunu başlat",
  "Clubs": "Kulüpler",
  "Legends": "Efsaneler",
  "Tournaments": "Turnuvalar",
  "Your board — pick a tile": "Senin tahtan — bir karo seç",
  "AI is picking a tile…": "Yapay zeka bir karo seçiyor…",
  "AI plays for {v}": "Yapay zeka {v} için oynuyor",
  "AI banks it": "Yapay zeka kasaya ekledi",
  "AI is wrong — steal it!": "Yapay zeka yanlış — çal onu!",
  "STEAL for {v}!": "{v} için ÇAL!",
  "For {v}": "{v} için",
  "Final banks — you {a}, AI {b}.": "Son kasalar — sen {a}, yapay zeka {b}.",
  "New board": "Yeni pano",
  "Last One Standing": "Son Ayakta Kalan",
  "{n} enter, one survives — make every cut": "{n} girer, biri hayatta kalır — her elemede isabetli ol",
  "Alive": "Hayatta",
  "Battle royale quiz": "Battle royale quiz",
  "Every round the field is cut — answer right and fast to stay in it. Nine rounds from {n} players down to one.": "Her turda saha daralır — oyunda kalmak için doğru ve hızlı cevap ver. Dokuz turda {n} oyuncudan bire düşülür.",
  "Kick off": "Başlangıç",
  "Continue": "Devam et",
  "A legendary goal replays on the coaching board. Name it — the first solve of each goal pays coins and XP.": "Efsanevi bir gol antrenman tahtasında tekrar oynatılıyor. Adını söyle — her golün ilk çözümü jeton ve XP kazandırır.",
  "A legendary goal replays on the coaching board. Watch the moves and name the goal.": "Efsanevi bir gol antrenman tahtasında tekrar oynatılıyor. Hareketleri izle ve golün adını söyle.",
  "Back tomorrow": "Yarın görüşürüz",
  "All {limit} goals played — come back tomorrow": "Tüm {limit} goller oynandı — yarın tekrar gel",
  "{left} of {limit} goals left today": "Bugün {limit} golden {left} kaldı",
  "Daily coins earned — more tomorrow": "Bugün kazanılan jetonlar — yarın daha fazlası",
  "Today: {today}/{cap} coins": "Bugün: {today}/{cap} jeton",
  "Your collection": "Koleksiyonun",
  "Fastest {cap} survive": "En hızlı {cap} hayatta kalır",
  "Field": "Saha",
  "You made the cut!": "Eleme turunu geçtin!",
  "#{rank} fastest — {cap} players remain.": "En hızlı #{rank} — {cap} oyuncu kaldı.",
  "Cut!": "Kestik!",
  "Finished #{place} of {n}": "#{place}. bitirdin, {n} kişi arasından",
  "Round {r} was your last — the field marched on without you.": "{r}. tur son turundu — saha sensiz ilerledi.",
  "Re-enter": "Tekrar Gir",
  "CHAMPION!": "ŞAMPİYON!",
  "{n} started. You are the last one standing.": "{n} başladı. Ayakta kalan son kişisin.",
  "Defend the title": "Unvanı savun",
  "Golden Goal": "Altın Gol",
  "Sudden death — push the ball into their net": "Tek gol — topu rakip kaleye sok.",
  "Round": "Tur",
  "Both of you answer the same question — faster and righter pushes the ball. Reach ±{n} and it is a goal. First goal wins.": "İkiniz de aynı soruyu cevaplıyorsunuz — daha hızlı ve doğru cevap rakip kaleye doğru ilerler. ±{n}'ye ulaşınca gol olur. İlk gol maçı kazanır.",
  "AI net": "Yapay Zeka kalesi",
  "Your attack": "Senin atağın",
  "GOLDEN GOAL!": "ALTIN GOL!",
  "AI scores": "Yapay Zeka gol atıyor",
  "Decided in {n} rounds.": "{n} turda karar verildi.",
  "Rematch": "Tekrar Oyna",
  "vs": "vs",
  "Career Race": "Kariyer Yarışı",
  "The transfer trail reveals — buzz before your rival": "Transfer yolu açılıyor — rakibinden önce bas",
  "Clubs appear one by one. Buzz early for 100 points — every extra club cuts the prize. Wrong buzz and you are out of the round. Best of {n}.": "Kulüpler tek tek belirir. 100 puan için erken bas, her eklenen kulüp ödülü azaltır. Yanlış basışta tur dışısın. En iyi {n}.",
  "Start race": "Yarış başlasın",
  "Buzz now: {pts} pts": "Şimdi bas: {pts} puan",
  "Locked out": "Engellendin",
  "BUZZ!": "BAS!",
  "Rival buzzed wrong — they are out!": "Rakip yanlış bastı — tur dışı!",
  "Your rival is watching the same trail…": "Rakibin de aynı yolu izliyor…",
  "Whose career is this?": "Bu kimin kariyeri?",
  "Wrong — locked out!": "Yanlış — engellendin!",
  "⚡ Rival buzzes…": "⚡ Rakip basıyor…",
  "+{pts} — yours!": "+{pts} — senin!",
  "Rival takes {pts}": "Rakip {pts} aldı",
  "Nobody got it": "Kimse bilemedi",
  "It was {name}": "{name} idi",
  "You win the race!": "Yarışı sen kazandın!",
  "Rival wins": "Rakip kazandı",
  "Race again": "Tekrar yarış",
  "Closest Wins": "En Yakın Tahmin",
  "No options, no help — land your guess on the number": "Seçenek yok, yardım yok — tahminini sayıya denk getir",
  "Score": "Skor",
  "{n} numeric stats — slide to your best guess. The closer you land, the more you score; a perfect hit pays a bullseye bonus.": "{n} sayısal istatistik — en iyi tahminine kaydır. Ne kadar yaklaşırsan o kadar çok puan alırsın; tam isabet bonus kazandırır.",
  "Take aim": "Nişan al",
  "Target {n} / {total}": "Hedef {n} / {total}",
  "Lock it in": "Kilitle",
  "Answer": "Cevapla",
  "BULLSEYE! +{pts}": "GÖZÜN KULAĞIN! +{pts}",
  "+{pts} pts": "+{pts} puan",
  "You were {diff} off.": "{diff} farkla ıskaladın.",
  "Next target": "Sonraki hedef",
  "Elite sniper!": "Elit keskin nişancı!",
  "Sharp shooter": "Keskin nişancı",
  "On the range": "Atış poligonunda",
  "Blindfolded": "Gözü bağlı",
  "{score} points over {n} targets": "{score} puan, {n} hedef üzerinden",
  "Reload": "Yeniden doldur",
  "Every shot is a 50/50 duel with the keeper. Answer questions to boost the payout — a wrong answer resets the boost.": "Her atış kaleciyle 50/50 bir düellodur. Ödemeyi artırmak için soruları cevapla — yanlış cevapta artış sıfırlanır.",
  "Boost {a}/{max} · ×{mult}": "Artış {a}/{max} · ×{mult}",
  "BOOSTED! Payout is now ×{mult}": "ARTIRILDI! Ödeme şimdi ×{mult}",
  "Wrong — boost resets to ×{mult}": "Yanlış — artış ×{mult} olarak sıfırlandı",
  "50/50 shot · current payout ×{mult}": "50/50 atış · mevcut ödeme ×{mult}",
  "Answer · boost to ×{next}": "Cevap · ×{next} artış",
  "Boosts raise the payout — the shot stays 50/50.": "Artışlar kazancı artırır — şut %50-%50 kalır.",
  "Boosting…": "Artırılıyor…",
  "Time's up — boost resets to ×{mult}": "Süre doldu — artış ×{mult} olarak sıfırlanır",
  "Left or right — the keeper picks one": "Sol veya sağ — kaleci birini seçer",
  "Pick your corner": "Köşeni seç",
  "Next attack risks the whole pot — the boost resets.": "Sonraki atak tüm potu riske atar — artış sıfırlanır.",
  "Run ×{run} → ×{next}": "Koşu ×{run} → ×{next}",
  "Run": "Koşu",
  "Answering is locked this attack — take the shot.": "Bu atakta cevaplama kilitli — şutu kullan.",
  "Sound settings": "Ses ayarları",
  "Crowd": "Seyirci",
  "Effects": "Efektler",
  "Off": "Kapalı",
  "More open zones = better odds of keeping the run alive.": "Daha açık alanlar = koşuyu sürdürme şansını artırır.",
  "The goal opens with 2 zones and one hidden keeper. Answer questions to open up to 6 — a wrong answer slams it back to 2.": "Kale 2 alan ve gizli bir kaleci ile açılır. 6'ya kadar açmak için soruları cevapla — yanlış cevap kaleyi tekrar 2 alana kapatır.",
  "{k} open · {pct}% · ×{mult}": "{k} açık · %{pct} · ×{mult}",
  "Zone opened! {k} of {max} in play": "Alan açıldı! {k}/{max} oyunda",
  "Pick your angle and shoot · {pot} → {next}": "Açını seç ve şut çek · {pot} → {next}",
  "Wrong — goal slams back to {n} zones": "Yanlış — kale {n} alana geri kapandı",
  "{k} zones open · 1 keeper hidden · {pct}% goal": "{k} bölge açık · 1 kaleci gizli · %{pct} gol",
  "Answer · open zone {n}": "Cevapla · açık bölge {n}",
  "Shoot · {pot} → {next}": "Şut at · {pot} → {next}",
  "More zones = safer shot, smaller payout — the maths favours knowing.": "Daha çok bölge = daha güvenli şut, daha az kazanç — matematik bilmekten yana.",
  "Opening the goal…": "Kaleyi açılıyor…",
  "Read the question…": "Soruyu oku…",
  "Time's up — the goal slams back to {n} zones": "Süre doldu — kale {n} bölgeye geri kapandı",
  "Wrong — the goal slams back to {n} zones": "Yanlış — kale {n} bölgeye geri kapandı",
  "{k} zones open — one hides the keeper": "{k} bölge açık — biri kaleciyi saklıyor",
  "{pct}% goal": "%{pct} gol",
  "Next attack risks the whole pot — the goal resets to {n} zones.": "Sıradaki atak tüm potu riske atıyor — kale {n} bölgeye sıfırlandı.",
  "Guess the Card": "Kartı Tahmin Et",
  "FIFA Cards": "FIFA Kartları",
  "Spin for a FIFA edition, then name the player from the stats": "Bir FIFA edisyonu için çevir, sonra oyuncuyu istatistiklerden bul",
  "Spinning the edition…": "Edisyon çevriliyor…",
  "Locked in!": "Kilitlendi!",
  "Guess the player from the drawn edition": "Çekilen edisyondan oyuncuyu tahmin et",
  "Card": "Kart",
  "No clues": "İpucu yok",
  "{clue} unlocks in": "{clue} açılıyor",
  "Final clue — answer now": "Son ipucu — şimdi cevapla",
  "Name the player…": "Oyuncunun adını söyle…",
  "Named on stats alone": "Sadece istatistiklerle belirlendi",
  "Guessed with {n} clue(s)": "{n} ipucuyla tahmin edildi",
  "Round complete": "Tur tamamlandı",
  "of {max} · {n}/{total} named": "{max} içinde · {n}/{total} isim söylendi",
  "Card {n}/{total}": "Kart {n}/{total}",
  "Spin for a FIFA edition, then name the player from the card": "FIFA sürümü için çevir, sonra karttan oyuncuyu bul",
  "Give up": "Pes etmek",
  "Wrong!": "Yanlış!",
  "Medium": "Orta",
  "Very hard": "Çok zor",
  "Medium/Easy": "Orta/Kolay",
  "Pre-FIFA 20": "FIFA 20 öncesi",
  "Tap a lock to reveal a clue": "İpucu görmek için bir kilide dokun",
  "Clue revealed": "İpucu açıldı",
  "The answer": "Cevap",
  "{clue} unlocks next": "{clue} bir sonrakini açar",
  "Nice — +{p}": "Güzel — +{p}",
  "Daily complete!": "Günlük tamamlandı!",
  "Today's round is done": "Bugünkü tur tamamlandı",
  "Coins earned": "Kazanılan jetonlar",
  "Solved": "Çözüldü",
  "New cards at reset": "Sıfırlamada yeni kartlar",
  "Come back tomorrow": "Yarın tekrar gel",
  "Reveal clue": "İpucunu göster",
  "Hidden clue": "Gizli ipucu",
  "Back to challenges": "Meydan okumalara dön",
  "A gold card, stats only — name the player across 10 editions.": "Sadece istatistiklerden oluşan altın kart — 10 maçta oyuncuyu tahmin et.",
  "Tap a lock to buy that clue": "O ipucunu almak için bir kilide dokun",
  "Today {n} pts": "Bugün {n} puan",
  "Correct now = {n} pts": "Şimdi doğru = {n} puan",
  "Not {name} · −{n} coins": "{name} değil · −{n} jeton",
  "Revealed": "Açıldı",
  "Reveal {clue} for {n} coins": "{clue} ipucunu {n} jeton karşılığında aç",
  "Hint budget": "İpucu bütçesi",
  "Hint budget: {n} pts": "İpucu bütçesi: {n} puan",
  "Hint budget resets every card · separate from your coins": "Bütçe her kartta yenilenir · jetonlarınla ilgisi yok",
  "Not {name} · −{n} pts": "{name} değil · −{n} puan",
  "Reveal {clue} for {n} pts": "{clue} ipucunu {n} puana aç",
  "Buy clues on the card, name the player, keep your points": "Karttan ipucu al, oyuncuyu bul, puanlarını koru",
  "Hints bought: {n}": "Alınan ipucu: {n}",
  "No hints bought": "Hiç ipucu alınmadı",
  "+{n} pts saved by skipping hints": "İpucu almayarak +{n} puan korudun",
  "No points on a surrendered card": "Pes edilen kart puan getirmez",
  "Next card": "Sıradaki kart",
  "See results": "Sonuçları gör",
  "{n} pts": "{n} puan",
  "Points saved through deduction": "Çıkarımla korunan puan",
  "Across {n} solved cards": "{n} çözülen kartta",
  "photo": "fotoğraf",
  "nation": "milliyet",
  "position": "pozisyon",
  "club": "kulüp",
  "league": "lig",
  "POS": "POZ",
  "NATION": "MİLLET",
  "LEAGUE": "LİG",
  "CLUB": "KULÜP",
  "Dealing…": "İşlem yapılıyor…",
  "Your card": "Kartın",
  "Buy clues on the card, name the player, keep your coins": "Karttaki ipuçlarını satın al, oyuncuyu tahmin et, jetonlarını koru",
  "Start": "Başla",
  "Run complete": "Koşu tamamlandı",
  "Rival": "Rakip",
};
